import React from 'react'
import { Navigate, useParams } from 'react-router-dom'

import { useSingleLocation } from '../hooks/useLocations'

import Spinner from '../components/Spinner'
import UnclaimedView from '../components/LocationSingle/UnclaimedView'
import ClaimedView from '../components/LocationSingle/ClaimedView'
import PendingView from '../components/LocationSingle/PendingView'

const LocationSingle: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const location = useSingleLocation(id)

  if (location.isLoading) {
    return (
      <div className="flex h-32 items-center justify-center">
        <Spinner className="h-10 w-10" />
      </div>
    )
  }

  if (!location.data) return <Navigate to="/locations" />

  if (location.data.claimStatus === 'UNCLAIMED') {
    return <UnclaimedView id={location.data.id} name={location.data.name} address={location.data.address} />
  }

  if (location.data.claimStatus === 'PENDING') {
    return <PendingView data={location.data} />
  }

  return <ClaimedView data={location.data} />
}

export default LocationSingle
